// extracted by mini-css-extract-plugin
export var buttonCopyWalletAddress = "ButtonCopyWalletAddress_buttonCopyWalletAddress__em4yN";
export var icon = "ButtonCopyWalletAddress_icon__UcNGB";
export var rotate = "ButtonCopyWalletAddress_rotate__Xu+6o";
export var dotty = "ButtonCopyWalletAddress_dotty__hvh99";